'use client'
import React from 'react'
import Navigation from '@dashboard/components_v2/global/Navigation'
import Flex from '@dashboard/components/Flex'
import useMeV2 from '@crystal-eyes/hooks/user/useMeV2'
import { usePathname, useSearchParams } from 'next/navigation'
import { useScreenDetector } from '@dashboard/hooks/useScreenDetector'

interface OwnProps {
  children: React.ReactNode
}

export default function MainContent({ children }: OwnProps) {
  const { data: me } = useMeV2()
  const searchParams = useSearchParams()
  const isOnboardingFlow = searchParams?.get('onboarding') === 'true'
  const sideNavEnabled = me?.sidenavFeatureFlag
  const pathName = usePathname()
  const { isTablet } = useScreenDetector()
  const isMobileAssessmentPage = isTablet && pathName === '/app/assessment'

  const isAssessmentAndOnboarding =
    pathName === '/app/assessment' && isOnboardingFlow

  const shouldRenderHeader =
    pathName !== '/app/onboarding' &&
    !isAssessmentAndOnboarding &&
    pathName !== '/app/terms'
  return sideNavEnabled ? (
    <Flex disable={isMobileAssessmentPage}>
      {shouldRenderHeader && <Navigation />}
      {children}
    </Flex>
  ) : (
    <>
      {shouldRenderHeader && <Navigation />}
      {children}
    </>
  )
}
